var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"bounce"}},[(_vm.content.isItOk)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"float-right abtg__saveMode"},[_vm._v("Salvato!")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }